import { API_HEADERS, REACT_APP_LIFERAY_HOST, VENTE_ENDPOINT } from "./utils";



export default class ServicePrincipal {


    // ✅ Fetch Genres Données
    async fetchVentes(venteId) {
        const url = `${REACT_APP_LIFERAY_HOST}${VENTE_ENDPOINT}/${venteId}`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: API_HEADERS
            });
            if (!response.ok) {
                throw new Error(`Erreur HTTP: ${response.status}`);
            }
            const data = await response.json();
            console.log("🚀 ~ ServicePrincipal ~ fetchVentes ~ data:", data)
            return data;
        } catch (error) {
            console.log("🚀 ~ GestionIdentifiantAffaire ~ fetchTypeBienNature ~ error:", error)
            throw error;
        }
    }

}


